import React, { useContext } from 'react';
import { UiContext } from 'States/ui/uiState';
import Text from 'Components/shared/Text';
import DefaultCardButtonGroup from 'Components/shared/cards/DefaultCardButtonGroup';

const CustomCard = ({
  name = '',
  caption = '',
  summary = '',
  price = '',
  iconUrl = '',
  buttons = [],
  svg,
  dataQa,
  buttonGroup = DefaultCardButtonGroup,
}) => {
  const {
    breakpoints: { sm },
  } = useContext(UiContext);

  const iconSize = sm ? '163px' : '226px';

  return (
    <div
      data-qa={dataQa}
      className="grid w-full bg-3"
      style={{
            width: '100%',
            maxWidth: '340px',
            gridTemplate: `"icon" "description"
                             "buttons"`,
            gridTemplateRows: `max(35%, ${iconSize}) minmax(0, 1fr) auto`,
            borderRadius: '20px',
            paddingBottom: '30px',
      }}
    >
      {iconUrl ? (
        <img
          alt={`${name}`}
          src={`${iconUrl}`}
          style={{
            height: "100%",
            width: "100%",
            objectFit: 'cover',
            gridArea: 'icon',
            borderRadius: '20px 20px 0 0',
            aspectRatio: '3/2'
          }}
        />
      ) : null}
      {svg ? (
        <div
          data-qa={`${dataQa}-imageWrapper`}
          className="bg-lightGrey flex justify-center items-center rounded md:rounded-none md:rounded-t"
          style={{
            height: iconSize,
            minWidth: iconSize,
            gridArea: 'icon'
          }}
        >
          {svg}
        </div>
      ) : null}
      <div
        className="flex flex-col px-16 mt-10"
        style={{ gridArea: 'description' }}
      >
        {caption ? (
          <Text
            textStyle="text-small"
            data-qa={`${dataQa}-caption`}
          >
            {caption}
          </Text>
        ) : null}
        <div
          data-qa={`${dataQa}-title`}
          className='font-bold color-8 mt-10'
          style={{
            fontSize: "26px",
            lineHeight: "28px"
          }}
        >
          {name}
        </div>
        <div
          className='bg-3-10 mb-10'
          style={{
            width: "55px",
            height: "1px",
            marginTop: "15px",
          }}
        ></div>
        {summary ? (
          <Text
            dataQa={`${dataQa}-summary`}
            style={{ marginBottom: "18px" }}
            className="break-words"
          >
            {summary}
          </Text>
        ) : null}
        {price ? (
          <Text
            textStyle="p2"
            dataQa={`${dataQa}-price`}
            style={{ marginBottom: "18px" }}
            className="break-words"
          >
            {price}
          </Text>
        ) : null}
      </div>
      {buttons && buttonGroup({ buttons, dataQa })}
    </div>
  );
};

export default CustomCard;
